import { Modal, Form, Button } from "react-bootstrap";

interface NewCampaignNameModalProps {
  show: boolean;
  name: string;
  onNameChange: (name: string) => void;
  onHide: () => void;
  onConfirm: () => void;
}

const NewCampaignNameModal = ({ show, name, onNameChange, onHide, onConfirm }: NewCampaignNameModalProps) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px", fontWeight: 600 }}>Name your campaign</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Campaign Name</Form.Label>
          <Form.Control
            type="text"
            autoFocus
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onConfirm();
              }
            }}
            placeholder="Untitled"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide} className="rounded">
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} className="rounded">
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewCampaignNameModal;
